<div class="blockheader">
  <button *ngIf="mapMode" class="btn_img btn_graydark btn_point" title="{{ 'Show on the map'| translate }}"></button>
  <button class="btn_img btn_graydark btn_photo" title="{{ 'Show photos from device'| translate }}"></button>
  <button class="btn_img btn_graydark btn_code" title="{{ 'Send command to device'| translate }}"></button>
  <!--button class="btn_img btn_graydark btn_time" title="{{ 'Create a task'| translate }}"></button-->
</div>
